/**
 * PokerRecentWinsTicker — Poker Room is hidden from customers while we polish
 * the multiplayer engine. This component renders nothing so the ticker (and its
 * /recent-wins fetch) no longer surfaces on the Casino Floor.
 *
 * See git history for the original social-proof implementation — restore it
 * when the Poker Room is re-enabled.
 */
export default function PokerRecentWinsTicker() {
    return null;
}
